import React from 'react'
const n = (num: number, precision = 1) =>
  (+num.toFixed(precision)).toLocaleString('de')

const differenceStrings = {
  /*

    GERMAN

    */
  de: [
    [30, 10000, 'deutlich mehr', 'als'],
    [10, 30, 'mehr', 'als'],
    [-10, 10, 'ähnlich viel', 'wie'],
    [-30, -10, 'weniger', 'als'],
    [-1000, -30, 'deutlich weniger', 'als']
  ],
  /*

    FRENCH

    */
  fr: [
    [30, 10000, 'beaucoup plus', 'que'],
    [10, 30, 'plus', 'que'],
    [-10, 10, 'autant', 'que'],
    [-30, -10, 'moins', 'que'],
    [-1000, -30, 'beaucoup moins', 'que']
  ]
}

const getDifString = (
  value: number,
  compare: number,
  language: 'de' | 'fr'
) => {
  let difstring = ['', '']
  const percentOfCompare = (value * 100) / compare - 100
  differenceStrings[language].map(([min, max, text, pro]) => {
    if (percentOfCompare > min && percentOfCompare <= max)
      difstring = [text.toString(), pro.toString()]
  })
  return difstring
}
export const RiskText = ({
  riskData,
  userInputs,
  LANGUAGE
}: {
  riskData: FormatedUserRiskDataType
  userInputs: UserInputTypes
  LANGUAGE: 'de' | 'fr'
}) => {
  const { gender, perweek = 0, risk = 'low' } = userInputs
  const { f, m, fSum, mSum } = riskData

  const stringGender_de = {
    /*

    GERMAN

    */
    user:
      gender === 'm'
        ? 'männlichen Umfrageteilnehmer'
        : 'weiblichen Umfrageteilnehmerinnen',
    other:
      gender === 'm' ? 'weiblichen Teilnehmerinnen' : 'männlichen Teilnehmern'
  }

  const stringGender_fr = {
    /*

    FRENCH

    */
    user:
      gender === 'm'
        ? "hommes qui ont participé à l'enquête"
        : "femmes qui ont participé à l'enquête",
    other:
      gender === 'm'
        ? "femmes qui ont participé à l'enquête"
        : "hommes qui ont participé à l'enquête"
  }

  const stringGender = LANGUAGE === 'de' ? stringGender_de : stringGender_fr

  const countGender = {
    user: gender === 'm' ? mSum : fSum,
    other: gender === 'm' ? fSum : mSum
  }
  console.log('countGender', countGender)
  const risksByGender: { [key: string]: { [key: string]: number } } = {
    none: {
      m: (m.none * 100) / mSum,
      f: (f.none * 100) / fSum
    },
    low: {
      m: (m.low * 100) / mSum,
      f: (f.low * 100) / fSum
    },
    middle: {
      m: (m.middle * 100) / mSum,
      f: (f.middle * 100) / fSum
    },
    high: {
      m: (m.high * 100) / mSum,
      f: (f.high * 100) / fSum
    }
  }

  const percentRisk = {
    user: gender === 'm' ? risksByGender[risk].m : risksByGender[risk].f,
    other: gender === 'm' ? risksByGender[risk].f : risksByGender[risk].m
  }

  /*

  GERMAN

  */

  const ListStrings_de: { [key: string]: string[] } = {
    none: [
      'Abstinent leben oder ganz selten Alkohol trinken',
      'abstinent leben oder ganz selten Alkohol trinken',
      'abstinent oder trinken ganz selten Alkohol.'
    ],
    low: ['Risikoarm trinken', 'risikoarm trinken', 'risikoarm'],
    middle: [
      'Möglicherweise risikoreich trinken',
      'möglicherweise risikoreich trinken',
      'möglicherweise risikoreich'
    ],
    high: ['Risikoreich trinken', 'risikoreich trinken', 'risikoreich']
  }

  const ListStrings_fr: { [key: string]: string[] } = {
    m: {
      none: [
        "Ceux qui s'abstiennent représentent",
        'des abstinents',
        'abstinent'
      ],
      low: [
        'Les hommes à faible risque représentent',
        'les buveurs à faible risque',
        'risikoarm'
      ],
      middle: [
        'les buveurs à risque potentiel',
        'les buveurs à risque potentiel',
        'les buveurs à risque potentiel'
      ],
      high: [
        'Risikoreich trinken',
        'des buveurs à risque',
        'les buveurs à risque'
      ]
    },
    f: {
      none: [
        "Celles qui s'abstiennent représentent",
        'des abstinentes',
        'abstinent'
      ],
      low: [
        'Les femmes à faible risque représentent',
        'les buveuses à faible risque',
        'risikoarm'
      ],
      middle: [
        'les buveuses à risque potentiel',
        'les buveuses à risque potentiel',
        'les buveuses à risque potentiel'
      ],
      high: [
        'Risikoreich trinken',
        'des buveuses à risque',
        'les buveuses à risque'
      ]
    }
  }

  const ListStrings = LANGUAGE === 'de' ? ListStrings_de : ListStrings_fr

  const list: { [key: string]: string[] } = {
    none: ['low', 'middle', 'high'],
    low: ['none', 'middle', 'high'],
    middle: ['none', 'low', 'high'],
    high: ['none', 'low', 'middle']
  }

  /*

  FRENCH

  */
  if (LANGUAGE === 'fr')
    return (
      <>
        <p>
          <b>
            Comme {n(percentRisk.user)}% des {countGender.user}{' '}
            {stringGender.user}
          </b>
          , vous faites partie du groupe <b>{ListStrings[gender][risk][1]}</b>.{' '}
          {list[risk].map((riskkey, pos) => {
            return (
              <React.Fragment key={'risk' + pos}>
                {
                  ListStrings[gender][riskkey][
                    pos === 0 ? 0 : pos === 1 && risk !== 'none' ? 1 : 2
                  ]
                }{' '}
                <b>{n(risksByGender[riskkey][gender])}%</b>
                {pos < 1 ? ', ' : pos === 1 ? ' et ' : '.'}
              </React.Fragment>
            )
          })}
        </p>
        <p>
          <b>{n(percentRisk.other)}%</b> des{' '}
          <b>
            {countGender.other} {stringGender.other}
          </b>{' '}
          se situent, comme vous, dans le groupe{' '}
          <b>{ListStrings[gender === 'm' ? 'f' : 'm'][risk][1]}</b>.{' '}
          {list[risk].map((riskkey, pos) => {
            return (
              <React.Fragment key={'risk2' + pos}>
                {
                  ListStrings[[gender === 'm' ? 'f' : 'm']][riskkey][
                    pos === 0 ? 0 : pos === 1 && risk !== 'none' ? 1 : 2
                  ]
                }{' '}
                <b>{n(risksByGender[riskkey][gender === 'm' ? 'f' : 'm'])}%</b>
                {pos < 1 ? ', ' : pos === 1 ? ' et ' : '.'}
              </React.Fragment>
            )
          })}
        </p>
      </>
    )
  /*

  GERMAN

  */
  return (
    <>
      <p>
        Damit gehören Sie zu den{' '}
        <b>
          {n(percentRisk.user)} Prozent der {countGender.user}{' '}
          {stringGender.user}
        </b>
        , die auch <b>{ListStrings[risk][1]}</b>.{' '}
        {list[risk].map((riskkey, pos) => {
          return (
            <React.Fragment key={'risk3' + pos}>
              {
                ListStrings[riskkey][
                  pos === 0 ? 0 : pos === 1 && risk !== 'none' ? 1 : 2
                ]
              }{' '}
              <b>{n(risksByGender[riskkey][gender])} Prozent</b>
              {pos < 1 ? ', ' : pos === 1 ? ' und ' : '.'}
            </React.Fragment>
          )
        })}
      </p>
      <p>
        Bei den{' '}
        <b>
          {countGender.other} {stringGender.other}
        </b>{' '}
        sind es <b>{n(percentRisk.other)} Prozent</b>, die{' '}
        <b>ebenfalls {ListStrings[risk][1]}</b>.{' '}
        {list[risk].map((riskkey, pos) => {
          return (
            <React.Fragment key={'risk4' + pos}>
              {
                ListStrings[riskkey][
                  pos === 0 ? 0 : pos === 1 && risk !== 'none' ? 1 : 2
                ]
              }{' '}
              <b>
                {n(risksByGender[riskkey][gender === 'm' ? 'f' : 'm'])} Prozent
              </b>
              {pos < 1 ? ', ' : pos === 1 ? ' und ' : '.'}
            </React.Fragment>
          )
        })}
      </p>
    </>
  )
}
